import { create } from 'zustand'

interface SearchState {
  connectionsSearch: string
  setConnectionsSearch: (query: string) => void
  clearConnectionsSearch: () => void
}

export const useSearchStore = create<SearchState>((set) => ({
  connectionsSearch: '',
  setConnectionsSearch: (query) => { set({ connectionsSearch: query }) },
  clearConnectionsSearch: () => { set({ connectionsSearch: '' }) },
}))